// Tokens for building embedded media source URLs
const EMBED_VALUE_TOKEN = '{EMBED_VALUE}'
const EMBEDDED_MEDIA_TOKENS = {
  embed: `${EMBED_VALUE_TOKEN}`,
  video: `${EMBED_VALUE_TOKEN}`,
  youtube: `https://www.youtube.com/embed/${EMBED_VALUE_TOKEN}`,
  vimeo: `https://player.vimeo.com/video/${EMBED_VALUE_TOKEN}`
}

export {
  EMBED_VALUE_TOKEN,
  EMBEDDED_MEDIA_TOKENS
}
